import { useEffect, useRef } from 'react'

// Hook personalizado principalmente para cerrar el modal de perfil (ubicado en la esquina superior derecha)
// al hacer clic fuera de él, pero se puede usar en más casos si se necesita. Esto soluciona el problema de que el modal no se cerraba automáticamente.
export default function useClickOutside(callbackFn) {
  const domNodeRef = useRef()

  useEffect(() => {
    const handler = (event) => {
      if (!domNodeRef.current?.contains(event.target)) {
        callbackFn()
      }
    }

    document.addEventListener('mousedown', handler)

    return () => {
      document.removeEventListener('mousedown', handler)
    }
  }, [])

  return domNodeRef
}
